import { typographyV2 } from '@toggle/design-system';
import Link from 'next/link';
import styled from 'styled-components';

import { AssetStatus } from '../../utils/search-utils/searchUtils';

export const ContainerLink = styled(Link)`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  mark {
    color: var(--text-primary);
    background-color: transparent;
  }
`;

export const Name = styled.span`
  ${typographyV2.bodySm};
`;

export const Ticker = styled.span`
  color: var(--text-soft);
  ${typographyV2.bodyXs}
`;

export const DateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  margin-left: 10px;
`;

const cardStyles = {
  beat: 'var(--text-success)',
  miss: 'var(--text-critical)',
  meet: 'var(--text-default)',
  analyzing: 'var(--text-soft)',
};

export const ReportedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ReportedPercent = styled.span<{
  status?: AssetStatus;
}>`
  color: ${({ status }) => (status ? cardStyles[status] : 'var(--text-soft)')};
  ${typographyV2.bodySm};
  font-family: var(--font-roboto-mono);
`;

export const ReportedLabel = styled.span<{
  status?: AssetStatus;
}>`
  color: ${({ status }) => (status ? cardStyles[status] : 'var(--text-soft)')};
  ${typographyV2.bodyXs};
`;
